import React from 'react';
import "./dashboardDoorSensor.css"
import openDoorFilled from "../../../assets/doorOpenFilled.svg";
import closeDoorFilled from "../../../assets/doorClosedFilled.svg"
import openDoorSolid from "../../../assets/doorOpenSolid.svg";
import closeDoorSolid from "../../../assets/doorClosedSolid.svg"
import doorSensorIcon from "../../../assets/blackDoorIcon.svg";
import sensorIcon from "../../../assets/sensorIcon.svg";

const DashboardDoorSensor = () => {
    return (
        <div className='dashboardDoorSensorMainContainer'>
            <div style={{marginLeft:"14px"}} className='dashboardDoorSensortopContainer' style={{ marginTop: "5px" }}>
                <div className='doorSensorIconDiv'>
                    <span ><img className='SensorIcon' src={sensorIcon} alt="SensorIcon" style={{display:"none"}}/></span>
                    <span><img className='doorSensorImg' src={doorSensorIcon} alt="doorSensorIcon" /></span>
                </div>
                <p className='EnvDataHeading' style={{ marginBottom: "5px" }}>Door Sensor</p>
            </div>
            <div className='dashboardDoorSensorBottomContainer'>
                <div className="doorSensorInfoTopContainer">
                    <p className='Temperature'>Door Status</p>
                </div>
                <div className="doorSensorInfoBottomContainer">
                    <div className='doorImgBox'>
                        <img className='doorImg' src={openDoorFilled} alt="doorImage" />
                    </div>
                    <p className='StatusInfo' >Open</p>
                </div>
            </div>
        </div>
    )
}

export default DashboardDoorSensor;